import React, { useEffect, useState } from "react";
import { ShieldCheck, Loader2, CheckCircle2, XCircle, RefreshCw } from "lucide-react";
import { toast } from "sonner";
import api, { formatError } from "@/lib/api";
import { Button } from "@/components/ui/button";

const fmt = (iso) => (iso ? new Date(iso).toLocaleString("ar-SA-u-ca-gregory-nu-latn", { timeZone: "Asia/Riyadh", dateStyle: "medium", timeStyle: "short" }) : "");

// زر الأدمن: يتأكد أن كل الأصوات المفعّلة تنطق فعلًا بالصوت المحفوظ ويعيد تفعيل المستنسخ المنتهي — دون الرجوع للمطوّر
export const VoiceHealth = ({ onDone }) => {
  const [rep, setRep] = useState(null);
  const load = async () => { try { const r = await api.get("/admin/voices/health"); setRep(r.data); return r.data; } catch { return null; } };
  useEffect(() => { load(); }, []);
  useEffect(() => {
    if (rep?.status !== "running") return;
    const t = setInterval(async () => { const d = await load(); if (d?.status === "done") { clearInterval(t); onDone?.(); toast[d.failed ? "warning" : "success"](d.failed ? `${d.failed} صوت يحتاج تدخلك` : "كل الأصوات تعمل بصوتها المحفوظ ✅"); } }, 3000);
    return () => clearInterval(t);
  }, [rep?.status]); // eslint-disable-line
  const run = async () => {
    try { const r = await api.post("/admin/voices/health"); setRep((x) => ({ ...(x || {}), status: "running", results: [] })); if (!r.data.started) toast.info("الفحص يعمل الآن بالفعل"); }
    catch (err) { toast.error(formatError(err.response?.data?.detail)); }
  };
  const running = rep?.status === "running";
  return (
    <div className="border border-border rounded-xl p-4 space-y-3" data-testid="voice-health-box">
      <div className="flex items-center justify-between gap-3 flex-wrap">
        <div>
          <div className="font-bold text-sm flex items-center gap-2"><ShieldCheck className="w-4 h-4 text-emerald-500" /> تأكد أن الأصوات تعمل</div>
          <p className="text-xs text-muted-foreground mt-1 leading-relaxed">ينطق جملة قصيرة بكل صوت مفعّل كما هو محفوظ. أي صوت مستنسخ انتهت صلاحيته عند المزوّد يُعاد تفعيله تلقائيًا من تسجيله الأصلي. {rep?.done_at && <span data-testid="voice-health-last">آخر فحص: {fmt(rep.done_at)}</span>}</p>
        </div>
        <Button onClick={run} disabled={running} className="gap-2 shrink-0" data-testid="voice-health-run">
          {running ? <Loader2 className="w-4 h-4 animate-spin" /> : <RefreshCw className="w-4 h-4" />} {running ? "جارٍ الفحص…" : "افحص الأصوات وأعد تفعيلها"}
        </Button>
      </div>
      {rep?.results?.length > 0 && (
        <ul className="grid sm:grid-cols-2 lg:grid-cols-3 gap-2" data-testid="voice-health-results">
          {rep.results.map((r) => (
            <li key={r.id} className={`rounded-lg px-3 py-2 text-xs flex items-start gap-2 border ${r.ok ? "border-emerald-500/30 bg-emerald-500/5" : "border-destructive/40 bg-destructive/5"}`} data-testid={`voice-health-${r.id}`}>
              {r.ok ? <CheckCircle2 className="w-4 h-4 text-emerald-500 shrink-0" /> : <XCircle className="w-4 h-4 text-destructive shrink-0" />}
              <div className="min-w-0">
                <div className="font-bold">{r.name} {r.reactivated && <span className="text-amber-600 font-normal">— أُعيد تفعيله</span>}</div>
                {!r.ok && <div className="text-destructive leading-snug break-words">{r.error}</div>}
                {r.ok && <div className="text-muted-foreground">يعمل بصوته المحفوظ</div>}
              </div>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};
